"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUsername;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useUsername() {
  return [(0, _useWebChatAPIContext.default)().username];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VVc2VybmFtZSIsInVzZVdlYkNoYXRBUElDb250ZXh0IiwidXNlcm5hbWUiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VVc2VybmFtZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVVzZXJuYW1lKCk6IFtzdHJpbmddIHtcbiAgcmV0dXJuIFt1c2VXZWJDaGF0QVBJQ29udGV4dCgpLnVzZXJuYW1lXTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBRWUsU0FBU0EsV0FBVCxHQUFpQztFQUM5QyxPQUFPLENBQUMsSUFBQUMsNkJBQUEsSUFBdUJDLFFBQXhCLENBQVA7QUFDRCJ9